import React from 'react';
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { SlashCircle, X } from 'react-bootstrap-icons';

const CancellationRequestedBadge = ({ onUndoClick, disabled = false, hideUndo = false }) => {
  const isDisabled = disabled || hideUndo;

  return (
    <Badge
      className={`cancellation-requested-badge py-0 px-2 border border-danger text-danger d-flex align-items-center${
        hideUndo ? ' opacity-75 py-1' : ''
      }`}
      style={hideUndo ? { pointerEvents: 'none' } : undefined}
    >
      <SlashCircle size={10} className="mr-1" />
      Cancellation Requested
      {!hideUndo && (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="undo-cancellation-tooltip">Undo cancellation</Tooltip>}
        >
          <span className="d-inline-flex">
            <button
              type="button"
              className="cancellation-requested-undo d-inline-flex align-items-center p-0 border-0 bg-transparent text-danger"
              aria-label="Undo cancellation"
              disabled={isDisabled}
              onClick={e => {
                e.stopPropagation();
                if (!isDisabled) onUndoClick?.();
              }}
            >
              <X size={18} />
            </button>
          </span>
        </OverlayTrigger>
      )}
    </Badge>
  );
};

export default CancellationRequestedBadge;
